import { Box, Container, Typography, TextField, Link, Button } from "@mui/material"
import Layout from "./Layout"
import theme from "./Theme"
import { SupportArticle as SupportArticleType } from "./Support";
import { useRef, useState } from "react";
import { router } from "@inertiajs/react";
import { Editor } from "@tinymce/tinymce-react";
import DeleteConfirmationDialog from "../components/DeleteConfirmationDialog";
interface User {
  role: string;
}

export default function SupportArticle(props: {user: User, article: SupportArticleType}) {
  const { title, category, content, published } = props.article;
  const [editing, setEditing] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const editorRef = useRef(null);

  const handleSave = () => {
    router.put(`/support/${props.article.id}`, {
      content: editorRef.current?.getContent(),
    });
    setEditing(false);
  }

  const handlePublish = () => {
    router.put(`/support/${props.article.id}`, {
      published: !published,
    });
  }

  const handleDelete = () => {
    router.delete(`/support/${props.article.id}`, {
      onSuccess: () => {
        router.get('/support');
      }
    });
  }

  return (
    <Layout title="Support">
      <Container>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3, mt: 9, width: '100%'}}>
          <Typography sx={{ color: theme.pandia.indigo_dark, fontWeight: 790 }} variant="h2">{title}</Typography>
          <Box display="flex" justifyContent="center" gap={8}>
            <Link href="/support" sx={{ color: theme.pandia.indigo_dark }}>
              <Typography sx={{ color: theme.pandia.indigo_dark }}>All support</Typography>
            </Link>
            <Link href={`/support/?category=${category}`} sx={{ color: theme.pandia.indigo_dark }}>
              <Typography sx={{ color: theme.pandia.indigo_dark }}>{category[0].toUpperCase() + category.slice(1)} support</Typography>
            </Link>
          </Box>
          <Box mt={4} width="100%" maxWidth="742px">
            {props.user.role === 'pandia_admin' && (
              <Box display="flex" gap={2} justifyContent="space-between">
                <Box display="flex" gap={2}>
                  <Button onClick={() => setEditing(!editing)}>{editing ? 'Cancel' : 'Edit'}</Button>
                  <Button onClick={handlePublish}>{published ? 'Unpublish' : 'Publish'}</Button> 
                  { editing && <Button onClick={handleSave}>Save</Button> }
                </Box>
                <Box display="flex" gap={2}>
                  <Button onClick={() => setOpenDialog(true)} color="error">Delete</Button>
                </Box>
              </Box>
            )}
            <DeleteConfirmationDialog
              title="Delete article"
              content="Are you sure you want to delete this article?"
              open={openDialog}
              onClose={() => setOpenDialog(false)}
              onConfirm={handleDelete}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', p: 3, gap: 3, border: '1px solid', borderColor: theme.palette.primary.main, borderRadius: '8px', maxWidth: '742px' }}>
              {editing ? (
                <Editor
                  initialValue={content}
                  onInit={(_evt, editor) => editorRef.current = editor}
                  tinymceScriptSrc="https://cdnjs.cloudflare.com/ajax/libs/tinymce/7.6.1/tinymce.min.js"
                  init={{
                    height: 500,
                    toolbar: 'image',
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount'
                    ]
                  }}
                />
              ) : (
                <>
                  <div dangerouslySetInnerHTML={{ __html: content }} />
                </>
              )}
            </Box>
          </Box>
        </Box>
      </Container>
    </Layout>
  )
}